module.exports = __webpack_public_path__ + "img/mappa-totem-1-small.c1ec2d6f.jpg";